import { render, staticRenderFns } from "./radish-cv-upload-new.vue?vue&type=template&id=130182c2&"
import script from "./radish-cv-upload-new.vue?vue&type=script&lang=js&"
export * from "./radish-cv-upload-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports